import $ from 'jquery';
import * as jwtJsDecode from 'jwt-js-decode';

import { getAccessToken, getApv } from './apis';
import {
  CONPAY_CLOSE_MESSAGE,
  IFRAME_TOP,
  IFRAME_WIDTH,
  IS_MOBILE,
} from './constants';
import { SDK_DOMAIN } from './constants';
import { replaceRouter, router, routes } from './router';
import { setDisableBackControl } from './utils/back-control';
import { amtFormatter, isEmpty } from './utils/common';
import { iframeBody, iframeHead, payLayer } from './views/components/common';

export const getIframeById = () => document.getElementById('iframe');

export const getIframe = () =>
  !isEmpty(getIframeById()) && getIframeById().contentWindow.document;

export const setIframeInnerHtml = (id, html) => {
  if (!isEmpty(getIframe())) getIframe().getElementById(id).innerHTML = html;
};
export const setIframeInnerText = (id, text) => {
  if (!isEmpty(getIframe())) getIframe().getElementById(id).innerText = text;
};
export const setIframeDisabled = (id, boolean) => {
  if (!isEmpty(getIframe())) getIframe().getElementById(id).disabled = boolean;
};
export const setIframeHidden = (id, boolean) => {
  if (!isEmpty(getIframe())) getIframe().getElementById(id).hidden = boolean;
};

export const setAddEventListener = (id, cb) => {
  if (!isEmpty(getIframe()))
    getIframe().getElementById(id).addEventListener('click', cb);
};

export const setAddChangeEventListener = (id, cb) => {
  if (!isEmpty(getIframe()))
    getIframe().getElementById(id).addEventListener('change', cb);
};

export const showBottomSheet = (id) => {
  $(function () {
    $(`iframe`)
      .contents()
      .find('body')
      .append('<div class="modal-backdrop show"></div>');
    $(`iframe`).contents().find(`#${id}_content`).slideDown(300);
    $(this).addClass('skin1_bod_in');

    // 모달 외부 영역 클릭시, bottomSheet 닫기------------
    $(`iframe`)
      .contents()
      .find('.modal-backdrop')
      .on('click', () => closeBottomSheet(id));
    // ------------------------------------------------

    $(`iframe`)
      .contents()
      .find('.close')
      .on('click', function () {
        $(this)
          .parents('.modal')
          .slideUp(300, function () {
            $(`iframe`).contents().find(`#${id}`).removeClass('skin1_bod_in');
            closeBackdrop();
          });
      });
  });
};

export const setBottomSheet = (id) => {
  $(function () {
    $(`iframe`)
      .contents()
      .find(`#${id}`)
      .on('click', function () {
        $(`iframe`)
          .contents()
          .find('body')
          .append('<div class="modal-backdrop show"></div>');
        $(`iframe`).contents().find(`#${id}_content`).slideDown(300);
        $(this).addClass('skin1_bod_in');

        // 모달 외부 영역 클릭시, bottomSheet 닫기------------
        $(`iframe`)
          .contents()
          .find('.modal-backdrop')
          .on('click', () => closeBottomSheet(id));
        // ------------------------------------------------
      });

    $(`iframe`)
      .contents()
      .find('.close')
      .on('click', function () {
        $(this)
          .parents('.modal')
          .slideUp(300, function () {
            $(`iframe`).contents().find(`#${id}`).removeClass('skin1_bod_in');
            closeBackdrop();
          });
      });
  });
};

export const closeBottomSheet = (id) => {
  // 검은 영역이 먼저 닫히고
  closeBackdrop();

  // bottom sheet 닫힘
  $(getIframe().getElementById(`${id}_content`)).slideUp(300, () => {
    $(`iframe`).contents().find(`#${id}`).removeClass('skin1_bod_in');
  });
};

/**
 * 컨펌성 modal: x버튼시 - 모달 close / 확인 버튼시 - callback
 * @param {string} triggerId
 * @param {string} modalId
 * @param {function} call
 */
export const setConfirmModal = (triggerId, modalId, call) => {
  $(function () {
    // z-index 수정
    $(`iframe`).contents().find(`.modal-dialog-centered`).css('zIndex', 1041);

    // 검은 배경 append
    $(`iframe`)
      .contents()
      .find(`#${triggerId}`)
      .on('click', function () {
        $(`iframe`).contents().find(`#${modalId}`).modal('show');
        $(`iframe`)
          .contents()
          .find(`#${modalId}`)
          .append('<div class="modal-backdrop show"></div>');
      });

    // 확인버튼 - callback
    $(`iframe`)
      .contents()
      .find(`#common_modal_commit`)
      .on('click', () => {
        closeBackdrop();
        call();
      });

    // 닫기 버튼 - modal close
    $(`iframe`)
      .contents()
      .find('.close')
      .on('click', () => {
        closeModal(modalId);
        closeBackdrop();
      });
  });
};

export const setModal = (triggerId, modalId) => {
  $(function () {
    $(`iframe`)
      .contents()
      .find(`#${triggerId}`)
      .on('click', function () {
        $(`iframe`).contents().find(`#${modalId}`).modal('show');
        $(`iframe`)
          .contents()
          .find('body')
          .append('<div class="modal-backdrop show"></div>');

        // 모달 외부 영역 클릭시, modal 닫기 시작 ------------
        $(`iframe`)
          .contents()
          .find(`#${modalId}`)
          .on('click', (e) => {
            // 1. 모달 근처 영역 클릭시 - 모달 닫기
            if (e.target.className.includes('c_modal')) {
              closeModal(modalId);
              closeBackdrop();
            } else {
              // 2. 모달 안쪽 영역 클릭시 - 리턴
              return;
            }
          });

        // 3. 검은 부분 클릭시 - 모달 닫기
        $(`iframe`)
          .contents()
          .find('.modal-backdrop')
          .on('click', () => {
            closeModal(modalId);
            closeBackdrop();
          });
        // ----------------------끝--------------------------
      });

    $(`iframe`)
      .contents()
      .find('.close')
      .on('click', () => closeBackdrop());
  });
};

/**
 * modal 닫기
 * @param modalId String
 */
export const closeModal = (modalId) => {
  $(`iframe`).contents().find(`#${modalId}`).modal('hide');
  closeBackdrop();
};

/**
 * backdrop 닫기
 */
export const closeBackdrop = () => {
  const backdropList = $(`iframe`).contents().find('.modal-backdrop');
  if (backdropList.length > 0) {
    for (let i = 0; i < backdropList.length; i++) {
      if (!isEmpty($(`iframe`).contents().find('.modal-backdrop')[i])) {
        $(`iframe`).contents().find('.modal-backdrop')[i].remove();
      }
    }
  }
};

export const closePopup = () => {
  const elem = getIframeById();

  if (elem != null) {
    window.postMessage(CONPAY_CLOSE_MESSAGE, '*');
    getIframeById().remove();
    document.getElementById('pay_layer').remove();

    removeCommonPrototype();
    removeCommonEventListener();
  }

  // remove hash
  const noHashURL = location.href.replace(/#.*$/, '');
  history.replaceState(null, null, noHashURL);
};

export const initLayer = async () => {
  initialCommonPrototype();
  initialCommonEventListener();
};

export const createLayer = () => {
  if (isEmpty(document.getElementById('pay_layer'))) {
    document.body.insertAdjacentHTML('beforeend', payLayer);
    getIframe().getElementsByTagName('head')[0].innerHTML = iframeHead;
    getIframe().getElementsByTagName('body')[0].innerHTML = iframeBody;
  }
};

export const checkLayerWrapper = () => {
  return !!document.getElementById('layer-wrapper');
};

export const removeLayer = async () => {
  !isEmpty(document.getElementById('pay_layer')) &&
    document.getElementById('pay_layer').remove();
};

export const layerResize = async () => {
  const width = document.documentElement.clientWidth;
  const height = document.documentElement.clientHeight;

  const left = !IS_MOBILE ? width / 2 - IFRAME_WIDTH / 2 : 0;
  const top = IFRAME_TOP;

  document.getElementById('pay_layer').style.position = 'fixed';
  document.getElementById('pay_layer').style.zIndex = '16777270';
  document.getElementById('pay_layer').style.top = '0';
  document.getElementById('pay_layer').style.left = '0';
  document.getElementById('pay_layer').style.width = `${width}px`;
  document.getElementById('pay_layer').style.height = `${height}px`;
  document.getElementById('pay_layer').style.display = 'block';
  document.getElementById('pay_layer').style.backgroundColor =
    'rgba(0, 0, 0, 0.5)';
  document.getElementById('pay_layer').style.backgroundRepeat = 'no-repeat';
  document.getElementById('pay_layer').style.backgroundSize = '100% 100%';
  document.getElementById('pay_layer').style.filter = 'alpha(opacity=50)';

  if (!isEmpty(getIframeById())) {
    getIframeById().contentWindow.focus();
    getIframeById().style.left = `${left}px`;
    getIframeById().style.top = `${top}px`;
    getIframeById().style.height = `${height}px`;
    if (IS_MOBILE) {
      getIframeById().style.width = `${width}px`;
    }
    document.getElementById('iframe').style.display = 'block';
  }
};

export const customizeStyle = () => {
  var r = getIframe().querySelector(':root');
  const style = JSON.parse(sessionStorage.getItem('CONPAY_CUSTOMIZE_OPTION'));

  if (style == null) return;

  // activeColor
  r.style.setProperty('--activeColor', style.activeColor);
  // formStyle
  if (style.formStyle == 'radius') {
    r.style.setProperty('--componentRadius', '20px');
  }
  if (style.formStyle == 'underline') {
    r.style.setProperty('--componentRadius', '0px');
    r.style.setProperty('--borderTop', '0px');
    r.style.setProperty('--borderRight', '0px');
    r.style.setProperty('--borderLeft', '0px');
  }
  // buttonStyle
  if (style.buttonStyle == 'radius') {
    r.style.setProperty('--btnRadius', '28px');
  }
  // navigationIcon.visible
  if (style.navigationIcon.visible == false) {
    r.style.setProperty('--backDisplay', 'none');
  }
  // navigationIcon.style
  if (style.navigationIcon.style == 'arrow') {
    r.style.setProperty('--backImage', 'url(../images/back_1.png)');
  }
};

export const stringToHTML = (str) => {
  var parser = new DOMParser();
  var doc = parser.parseFromString(str, 'text/html');
  return doc.body;
};

export const initialCommonPrototype = () => {
  Element.prototype.appendBefore = function (element) {
    element.parentNode.insertBefore(this, element);
  };

  Element.prototype.appendAfter = function (element) {
    element.parentNode.insertBefore(this, element.nextSibling);
  };
};

export const removeCommonPrototype = () => {
  delete Element.prototype.appendBefore;
  delete Element.prototype.appendAfter;
};

export const initialCommonEventListener = () => {
  window.addEventListener('hashchange', router);
  window.addEventListener('load', router);
};

export const initMessageEventListner = () => {
  window.addEventListener(
    'message',
    (e) => {
      if (process.env.KEYPAD_URL.startsWith(e.origin)) {
        closePopup();

        if (e.data.redirectTo == 'after-check') {
          const nextHash = sessionStorage.getItem('CONPAY_NEXT_HASH');
          let nextState = null;
          const nextStateStr = sessionStorage.getItem('CONPAY_NEXT_STATE');
          if (typeof nextStateStr != 'undefined') {
            nextState = JSON.parse(nextStateStr);
          }
          if (nextHash == routes.enterPwd.hashPath) {
            replaceRouter(nextState, null, nextHash, () => {
              setDisableBackControl();
            });
          } else {
            replaceRouter(nextState, null, nextHash);
          }
        }
        if (e.data.redirectTo == 'reset-pass') {
          replaceRouter(null, null, routes.resetPassStep1.hashPath, () => {
            setDisableBackControl();
          });
        }
        if (e.data.redirectTo == 'history-back') {
          // do nothing (키패드에서 history.back()은 SDK close 처리)
        }
      }
    },
    false
  );
};

export const removeCommonEventListener = () => {
  window.removeEventListener('hashchange', router);
  window.removeEventListener('load', router);
};

export const checkAccessToken = async (routePath) => {
  let isSatisfied = true;
  let hashPath = '';
  let message = '';

  // check token
  if (
    routePath != '#conpay_kmcert-callback' &&
    routePath != '#conpay_terms-view' &&
    routePath != '#conpay_result-page'
  ) {
    try {
      await getAccessToken();
      if (routePath == '#conpay_terms') {
        isSatisfied = false;
        hashPath = routes.close.hashPath;
      }
    } catch (e) {
      if (routePath != '#conpay_terms') {
        // Member Not Exist
        if (e.responseJSON.resultCode == 1) {
          // 약관동의 페이지 이동
          isSatisfied = false;
          hashPath = routes.terms.hashPath;
        } else {
          isSatisfied = false;
          hashPath = routes.resultPage.hashPath;
          message = '커넥트페이 토큰 발급 실패';
        }
      }
    }
  }
  return { isSatisfied, hashPath, message };
};

export const checkBrandService = (routePath) => {
  let isSatisfied = true;
  let hashPath = '';
  let message = '';

  const branInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));

  switch (routePath) {
    case '#conpay_card-regi': //카드 등록
      if (!branInfo.service.card) {
        isSatisfied = false;
        hashPath = routes.resultPage.hashPath;
        message = '브랜드 카드 서비스 이용 불가!';
      }
      break;
    case '#conpay_account-remitc': //계좌송금
      if (!branInfo.service.account) {
        isSatisfied = false;
        hashPath = routes.resultPage.hashPath;
        message = '브랜드 계좌 서비스 이용 불가!';
      }
      break;
    case '#conpay_charg-remitc': //머니송금
    case '#conpay_charg-remitc-uid': //머니머니송금
    case '#conpay_charg-deposit': //충전머니 층전
    case '#conpay_charg-deposit-auto': //충전머니 자동충전
    case '#conpay_charg-details': //충전머니 내역조회
      if (!branInfo.service.charge) {
        isSatisfied = false;
        hashPath = routes.resultPage.hashPath;
        message = '브랜드 충전머니 서비스 이용 불가!';
      }
      break;
    case '#conpay_online-pay':
      if (branInfo.bndBizDivCode == '1') {
        isSatisfied = false;
        hashPath = routes.resultPage.hashPath;
        message = '오프라인 브랜드 사용 불가!';
      }
      break;
    case '#conpay_onsite-pay':
      // if (branInfo.bndBizDivCode == '0') {
      //   isSatisfied = false;
      //   hashPath = routes.resultPage.hashPath;
      //   message = '온라인 브랜드 사용 불가!';
      // }
      break;
  }

  return { isSatisfied, hashPath, message };
};

export const checkAccount = async (routePath) => {
  let isSatisfied = true;
  let hashPath = '';
  let message = '';

  switch (routePath) {
    case '#conpay_account-remitc':
    case '#conpay_charg-remitc':
    case '#conpay_charg-remitc-uid':
    case '#conpay_charg-deposit':
    case '#conpay_charg-deposit-auto':
      try {
        const res = await getApv('common/methodList', false, false);
        if (res.accountList.length == 0) {
          isSatisfied = false;
          hashPath = routes.accountRegi.hashPath;
        }
      } catch (e) {
        isSatisfied = false;
        hashPath = routes.resultPage.hashPath;
        message = e;
      }
      break;
  }

  return { isSatisfied, hashPath, message };
};

export const decodeJWT = () => {
  const token = sessionStorage
    .getItem('CONPAY_API_KEY')
    .replace('CONPAY_API_KEY ', '');
  const jwtSplit = jwtJsDecode.jwtSplit(token);
  const obj = jwtJsDecode.s2J(jwtJsDecode.zbu2s(jwtSplit.payload));

  //한글 인코딩 변환
  const name = obj.nm;
  const bufView = new Uint8Array(new ArrayBuffer(name.length));
  const utf8decoder = new TextDecoder();
  for (const i in bufView) bufView[i] = name.charCodeAt(i);

  obj.nm = utf8decoder.decode(bufView);
  return obj;
};

export const serialize = (jsonObject) => {
  return encodeURIComponent(JSON.stringify(jsonObject));
};

export const deserialize = (serializeStr) => {
  return JSON.parse(decodeURIComponent(serializeStr));
};

export const sortMethod = (a, b) => {
  if (a.mainUseYn < b.mainUseYn) {
    return 1;
  }
  if (a.mainUseYn > b.mainUseYn) {
    return -1;
  }
  return 0;
};

export const clearStorage = (userKey) => {
  const beforeUserKey = sessionStorage.getItem('CONPAY_USER_KEY');
  if (beforeUserKey != userKey) {
    localStorage.removeItem('CONPAY_MAIN_ACCOUNT');
    localStorage.removeItem('CONPAY_SELECTED_METHOD');
    localStorage.removeItem('CONPAY_SELECTED_METHOD_INFO');
  }

  sessionStorage.removeItem('CONPAY_BRAND_INFO');
  sessionStorage.removeItem('CONPAY_API_KEY');
  sessionStorage.removeItem('CONPAY_USER_KEY');
  sessionStorage.removeItem('CONPAY_USER_EMAIL');
  sessionStorage.removeItem('CONPAY_REDIRECT_URL');
  sessionStorage.removeItem('CONPAY_CUSTOMIZE_OPTION');
  sessionStorage.removeItem('CONPAY_NEXT_HASH');
  sessionStorage.removeItem('CONPAY_NEXT_STATE');
};

// 은행선택
export const getBankModalLayer = async () => {
  let bankListHtml = '';

  try {
    // 은행코드
    const resultData = await getApv('common/code?grpCode=BNK_CODE');
    if (resultData == null) {
      throw '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
    }
    const bankListResult = resultData
      .filter((bank) => bank.useYn == 'Y' && bank.ref1 != null)
      .map((bank) => ({
        order: bank.sortOrder,
        bankCd: bank.codeId,
        bankNm: bank.codeName,
        logoImg: bank.ref1,
      }));

    bankListResult.forEach((bank) => {
      bankListHtml += `<div><img src="${SDK_DOMAIN}/images/${
        bank.logoImg
      }" value="${serialize(bank)}" /></div>`;
    });
  } catch (e) {
    throw e.resultMessage || e;
  }

  return `
    <div class="modal c_btm1" id="bank_select_content">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">은행선택</h5>
                    <button type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div id="bank_list" class="modal-body c_box c_bank">
                    ${bankListHtml}
                </div>
            </div>
        </div>
    </div>
`;
};

// 계좌선택
export const getAccountModalLayer = async () => {
  let accountListHtml = '';

  try {
    // 결제수단 조회
    const methodListResult = await getApv('common/methodList');

    // 연결계좌 리스트
    methodListResult.accountList.forEach((account) => {
      let mainUseHtml = '';
      let itemClass = 'c_label6_1';

      if (account.mainUseYn == 'Y') {
        localStorage.setItem('CONPAY_MAIN_ACCOUNT', serialize(account));
        mainUseHtml = '<span class="skin1_span c_span1">주계좌</span>';
        itemClass = 'c_label6';
      }

      accountListHtml += `<div id="${
        account.accEntyno
      }" class="item ${itemClass}" value="${serialize({
        trDiv: '2001',
        ...account,
      })}">${account.bnkName} ${account.accno} ${mainUseHtml}</div>`;
    });
  } catch (e) {
    throw e.resultMessage;
  }

  return `
  <div class="modal c_btm1" id="account_select_content">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">계좌선택</h5>
                  <button type="button" class="close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div id="deposit_account_list" class="modal-body">
                  ${accountListHtml}
                  <div id="account_regi" class="item c_label6_1">+ 계좌추가</div>
              </div>
          </div>
      </div>
  </div>
`;
};

// 연결계좌 클래스 세팅
export const setAccountClass = (oldEntyno, newEntyno) => {
  getIframe().getElementById(newEntyno).classList.remove('c_label6_1');
  getIframe().getElementById(newEntyno).classList.add('c_label6');

  if (!isEmpty(oldEntyno)) {
    getIframe().getElementById(oldEntyno).classList.remove('c_label6');
    getIframe().getElementById(oldEntyno).classList.remove('c_label6_1');
  }
};

// 결제수단선택
export const getMethodModalLayer = async () => {
  let itemClass = '';
  let methodListHtml = '';
  let moneyBalance = 0;

  let selectedMethod = localStorage.getItem('CONPAY_SELECTED_METHOD');
  const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));

  // 충전머니
  if (brandInfo.service.charge) {
    try {
      // 충전머니 잔액조회
      const meneyBalanceResult = await getApv('charging/moneyBalance');
      moneyBalance = meneyBalanceResult.chrgBal || 0;
    } catch (e) {
      throw e.resultMessage;
    }

    itemClass = selectedMethod == 'money' ? 'c_label6' : 'c_label6_1';
    methodListHtml += `<div class="item ${itemClass}" value="${serialize({
      trDiv: '3001',
      moneyBalance,
    })}">충전머니 ${amtFormatter(moneyBalance)} 원</div>`;

    if (selectedMethod == 'money') {
      // selectedMethod = 'money';
      localStorage.setItem('CONPAY_SELECTED_METHOD', 'money');
      localStorage.setItem(
        'CONPAY_SELECTED_METHOD_INFO',
        serialize({ trDiv: '3001', moneyBalance })
      );
    }
  }

  try {
    // 결제수단 조회
    const methodListResult = await getApv('common/methodList');

    // 카드
    if (brandInfo.service.card) {
      methodListResult.cardList.sort(sortMethod);
      methodListResult.cardList.forEach((card) => {
        itemClass =
          selectedMethod == card.cardEntyno ? 'c_label6' : 'c_label6_1';
        const mainUseHtml =
          card.mainUseYn == 'Y'
            ? `<span class="skin1_span c_span1">주카드</span>`
            : '';
        methodListHtml += `<div id="${
          card.cardEntyno
        }" class="item ${itemClass}" value="${serialize({
          trDiv: '1001',
          ...card,
        })}">${card.cardCoName} ${cardNumberForm(card.cardBin)}
          ${mainUseHtml}</div>`;

        if (selectedMethod == null) {
          selectedMethod = card.cardEntyno;
          localStorage.setItem('CONPAY_SELECTED_METHOD', card.cardEntyno);
          localStorage.setItem(
            'CONPAY_SELECTED_METHOD_INFO',
            serialize({ trDiv: '1001', ...card })
          );
        }
      });
    }

    // 계좌
    if (brandInfo.service.account) {
      methodListResult.accountList.sort(sortMethod);
      methodListResult.accountList.forEach((account) => {
        itemClass =
          selectedMethod == account.accEntyno ? 'c_label6' : 'c_label6_1';
        const mainUseHtml =
          account.mainUseYn == 'Y'
            ? `<span class="skin1_span c_span1">주계좌</span>`
            : '';
        methodListHtml += `<div id="${
          account.accEntyno
        }" class="item ${itemClass}" value="${serialize({
          trDiv: '2001',
          ...account,
        })}">${account.bnkName} ${account.accno} ${mainUseHtml}</div>`;

        if (selectedMethod == null) {
          selectedMethod = account.accEntyno;
          localStorage.setItem('CONPAY_SELECTED_METHOD', account.accEntyno);
          localStorage.setItem(
            'CONPAY_SELECTED_METHOD_INFO',
            serialize({ trDiv: '2001', ...account })
          );
        }
      });
    }
  } catch (e) {
    throw e.resultMessage;
  }

  return `
    <div class="modal c_btm1" id="payment_method_content">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">결제수단 선택</h5>
                  <button type="button" class="close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div id="payment_method_list" class="modal-body">
                ${methodListHtml}
                <div id="pay_method_regi" class="item c_label6_1">+ 결제수단 추가</div>
              </div>
          </div>
      </div>
    </div>
  `;
};

// 결제수단추가
export const getMethodRegiModalLayer = async () => {
  let methodRegiListHtml = '';
  const payMethodList = [];

  const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
  if (brandInfo.service.charge || brandInfo.service.account) {
    payMethodList.push({
      name: '계좌 등록',
      hashPath: routes.accountRegi.hashPath,
    });
  }
  if (brandInfo.service.card) {
    payMethodList.push({
      name: '카드 등록',
      hashPath: routes.cardRegi.hashPath,
    });
  }
  if (brandInfo.service.charge) {
    payMethodList.push({
      name: '충전머니 충전',
      hashPath: routes.chargDeposit.hashPath,
    });
  }

  payMethodList.forEach((method, index) => {
    methodRegiListHtml += `<div id="pay_method_regi_${index}" class="item c_label6_1" value="${method.hashPath}">${method.name}</div>`;
  });

  return `
    <div id="pay_method_regi_content" class="modal c_btm1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">결제수단 추가</h5>
            <button id="close_modal" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div>
            <div id="pay_method_regi_list" class="modal-body">
              ${methodRegiListHtml}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};

export const cardNumberForm = (cardBin) => {
  cardBin = (cardBin || '').padEnd(16, '*');
  const rex = /^(.{4})(.{4})(.{4})(.{4})$/;
  return cardBin.replace(rex, `$1-$2-$3-$4`);
};

/**
 * Numeric only
 * @params {String} triggerId
 */
export const setNumericOnly = (triggerId) => {
  getIframe()
    .getElementById(triggerId)
    .addEventListener('input', () => {
      getIframe().getElementById(triggerId).value = getIframe()
        .getElementById(triggerId)
        .value.replace(/[^0-9]/g, '')
        .replace(/(\..*)\./g, '$1');
    });
};

export const getLocationPath = () => {
  return location.origin + location.pathname;
};

export const setReturnPromiseForBrand = (resolve, reject) => {
  window.brandResolve = resolve;
  window.brandReject = reject;
};
